import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {
    httpCreateActivityReport,
    HttpCreateActivityReportPayload
} from '@/features/accesses/activity-report/http/activityReport.http'
import {ActivityReport, ActivityReportError} from '@/features/accesses/activity-report/types'

export const useStoreActivityReport = (
    options?: Omit<
        UseMutationOptions<ActivityReport, AxiosError<ActivityReportError>, HttpCreateActivityReportPayload>,
        'mutationKey' | 'mutationFn'
    >
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_ACTIVITY_REPORT],
        mutationFn: payload => httpCreateActivityReport(payload),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS]})
            options?.onSettled?.(...args)
        }
    })
